import axios from 'axios';


export const getGlobalFilter = (query: string) => {
  return axios.get(
    process.env.REACT_APP_API_GLOBAL_URL+`global-filter?where=` + query
  );
};
export const getSystemConfig = (query: string) => {
  return axios.get(
    process.env.REACT_APP_API_GLOBAL_URL+`system-config?where=` + query
  );
};
export const AddGlobalFilter = (obj: Object) => {
  return axios.put(process.env.REACT_APP_API_GLOBAL_URL+`global-filter/create`, obj);
};
export const EditGlobalFilter = (obj: Object) => {
  return axios.put(process.env.REACT_APP_API_GLOBAL_URL+`global-filter/update`, obj);
};
export const DeleteGlobalFilter = (obj: Object) => {
  return axios.put(process.env.REACT_APP_API_GLOBAL_URL+`global-filter/delete`, obj);
};
